import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { speak, TTS_VOICES } from '../services/ttsService';

const STORAGE_KEY = 'adhd-planner-tts';

const DEFAULT_SETTINGS = {
  enabled: false,
  gender: 'female',   // 'female' | 'male'
  volume: 0.9
};

export function useTTS() {
  const [settings, setSettings] = useLocalStorage(STORAGE_KEY, DEFAULT_SETTINGS);

  const announce = useCallback(async (text) => {
    if (!settings.enabled) return;
    try {
      await speak(text, { gender: settings.gender, volume: settings.volume });
    } catch (err) {
      console.error('[TTS] Échec de la lecture vocale :', err);
    }
  }, [settings]);

  const updateSettings = useCallback((updates) => {
    setSettings(prev => ({ ...prev, ...updates }));
  }, [setSettings]);

  return {
    ttsSettings: settings,
    updateTTS: updateSettings,
    announce,
    voices: TTS_VOICES
  };
}

export default useTTS;
